import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatDateTime'
})
export class FormatDateTimePipe implements PipeTransform {

  transform(value: any): any {
    var d = new Date(value);
    let date = new Date(value.substr(0,10));
    date.setHours(d.getUTCHours());
    date.setMinutes(d.getUTCMinutes());
    date.setSeconds(d.getUTCSeconds());
    
    return date;
  }

}
